export default "__VITE_ASSET__opTbosaQ__"